export interface HelpArticle {
  slug: string
  title: string
  description: string
  lastUpdated: string
  order: number
  type: string
  icon: string
  listed: boolean
  content: string
}

// ponytail: parse YAML frontmatter without gray-matter (needs Node Buffer)
function parseFrontmatter(raw: string) {
  const match = raw.match(/^---\r?\n([\s\S]*?)\r?\n---\r?\n([\s\S]*)$/)
  if (!match) return { data: {}, content: raw }

  const yaml = match[1]
  const content = match[2]
  const data: Record<string, string | number> = {}

  for (const line of yaml.split('\n')) {
    const [key, ...rest] = line.split(':')
    if (key && rest.length) {
      const value = rest
        .join(':')
        .trim()
        .replace(/^["']|["']$/g, '')
      data[key.trim()] = isNaN(Number(value)) ? value : Number(value)
    }
  }

  return { data, content }
}

const modules = import.meta.glob<string>('../../content/help/*.md', {
  query: '?raw',
  import: 'default',
  eager: true,
})

export function useHelpArticles() {
  const articles: HelpArticle[] = Object.entries(modules)
    .filter(([path]) => !path.endsWith('README.md'))
    .map(([path, raw]) => {
      const slug = path.split('/').pop()?.replace('.md', '') ?? ''
      const { data, content } = parseFrontmatter(raw)
      return {
        slug,
        title: (data.title as string) ?? slug,
        description: (data.description as string) ?? '',
        lastUpdated: (data.lastUpdated as string) ?? '',
        order: (data.order as number) ?? 99,
        type: (data.type as string) ?? 'Guide',
        icon: (data.icon as string) ?? 'i-lucide-file-text',
        listed: String(data.listed) !== 'false',
        content,
      }
    })
    .sort((a, b) => a.order - b.order)

  const getArticle = (slug: string) => articles.find((a) => a.slug === slug)

  return { articles, getArticle }
}
